export class Fit {
	constructor(idFit, fitDescription) {
		this.idFit = idFit;
		this.fitDescription = fitDescription;
	}
}
